import AppStoreIcon from '@home/assets/svg/dashboard/appstore.svg';
import GooglePlayIcon from '@home/assets/svg/dashboard/googleplay.svg';
import React, { FC } from 'react';
import { IMetricsCardWrapContentHeaderProps } from "@/pages/dashboard/pages/changeAnalysis/components/RankingChangeTable/components/MetricsCardWrapContentHeader/type";
import { ChangeAnalysisAiSummarySection } from '@/pages/dashboard/pages/changeAnalysis/components/ChangeAnalysisAiSummarySection';
import { Segment } from 'tea-component';
import { TPlatform } from '@/pages/dashboard/pages/changeAnalysis/components/RankingChangeTable/types';
import './index.scss';

export const MetricsCardWrapContentHeader: FC<IMetricsCardWrapContentHeaderProps> = (props) => {
  const {
    aiData,
    aiLoading,
    platform,
    handlePlatformChange,
  } = props;
  return (
    <div className="dbd-ranking-change-table__header">
      <ChangeAnalysisAiSummarySection data={aiData} loading={aiLoading} />
      <div className="dbd-ranking-change-table__platform-selector">
        <Segment
          options={[
            {
              text: (
                <span className="dbd-ranking-change-table__platform-option">
                  <img src={AppStoreIcon} alt={'App Store'} className="dbd-ranking-change-table__platform-option__icon" />
                  <span>App Store</span>
                </span>
              ),
              value: 'appStore'
            },
            {
              text: (
                <span className="dbd-ranking-change-table__platform-option">
                  <img src={GooglePlayIcon} alt={'Google Play'} className="dbd-ranking-change-table__platform-option__icon dbd-ranking-change-table__platform-option__icon--google-play" />
                  <span>Google Play</span>
                </span>
              ),
              value: 'googlePlay'
            },
          ]}
          value={platform}
          onChange={(value) => handlePlatformChange(value as TPlatform)}
        />
      </div>
    </div>
  );
};
